module.exports = __webpack_public_path__ + "3f086dbc376893f56b4a9c4d3cac5df9.ttf";